<template>
  <div class="params-stair-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="clickAdd" size="mini"
                     type="primary" icon="el-icon-plus">新增楼梯
          </el-button>
          <el-button @click="clickEdit" size="mini"
                     type="primary" icon="el-icon-edit">编辑楼梯
          </el-button>
          <el-button @click="setPoint('point1')" size="mini"
                     type="primary" icon="el-icon-location">设置定位1
          </el-button>
          <el-button @click="setPoint('point2')" size="mini"
                     type="primary" icon="el-icon-location">设置定位2
          </el-button>
          <el-button @click="del" size="mini" type="primary"
                     icon="el-icon-delete">删除楼梯
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table"
                :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="楼梯名称" prop="name"></el-table-column>
        <el-table-column label="楼梯口1甲板" prop="deck1_name"></el-table-column>
        <el-table-column label="楼梯口1过道" prop="passage1_name"></el-table-column>
        <el-table-column label="楼梯口1定位">
          <template slot-scope="scope">
            <el-button v-if="scope.row.point1.x!=0" size="mini" type="primary" plain>已设置</el-button>
            <el-button v-if="scope.row.point1.x==0" size="mini">未设置</el-button>
          </template>
        </el-table-column>
        <el-table-column label="楼梯口2甲板" prop="deck2.name"></el-table-column>
        <el-table-column label="楼梯口2过道" prop="passage2.name"></el-table-column>
        <el-table-column label="楼梯口2定位">
          <template slot-scope="scope">
            <el-button v-if="scope.row.point2.x!=0" size="mini" type="primary" plain>已设置</el-button>
            <el-button v-if="scope.row.point2.x==0" size="mini">未设置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog class="dialog-map" title="设置座标点" width="80%" :visible.sync="setPointDialogIsShow">
      <div style="width:100%;height:400px;">
        <v-ship-map-set-area ref="shipmap" @transmit="transmit"
                             containerHeight="400"
                             :shipMapData="dataToMap"
                             :ship_img="ship_img">
        </v-ship-map-set-area>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="emptyData">清空</el-button>
        <el-button size="mini" type="primary" @click="submitPassagePoint">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">楼梯名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">所在甲板1</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择甲板">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">所在过道1</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择过道">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">所在甲板2</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择甲板">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">所在过道2</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择过道">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  import {mock} from '../../common/js/mock2.js';
  import ShipMapSetArea from '../../components/ship-map-set-area.vue';
  export default {
    data() {
      return {
        ship_img: {
          url: '',
          width: 0,
          height: 0
        },
        setPointDialogIsShow: false,
        dataToMap: {},
        dataFromMap: {},
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {name: "", type: '特殊区域', count: 10},
        addDialogShow: false,
        unlockIsShow: false,
        hasBaseStationIds: [1, 2, 8],
        allBaseStations: [],
        activeName: 'first',
        value1: '',
        activeName22: 'first'
      };
    },

    computed: {},

    created() {
      this.getData();
      this.ship_img.width = 5000;
      this.ship_img.height = 1815;
      this.ship_img.url = '1111';
    },

    methods: {
      submitPassagePoint(){
        console.log(this.dataFromMap);
        alert('保存数据');
        this.setPointDialogIsShow = false;
      },

      transmit(data){
        console.log(JSON.stringify(data));
        this.dataFromMap = data;
      },

      emptyData(){
        this.$refs.shipmap.drawOnePointEsc();
      },

      setPoint(pointOrder){
        console.log(this.currentRow);
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.setPointDialogIsShow = true;
          this.dataToMap = {
            type: 'setOnePoint',
            data: {
              id: this.currentRow.id,
              direction: this.currentRow.direction,
              isPoint1: pointOrder === 'point1' ? true : false,
              point: pointOrder === 'point1' ? this.currentRow.point1 : this.currentRow.point2
            }
          };
          setTimeout(() => {
            this.$refs.shipmap.load();
          }, 10);
        }
      },

      setRightBottom(){
        console.log(this.currentRow);
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else if (this.currentRow.right_bottom.through === false) {
          tool.message('左/上禁止通行，无需设置', 'warning');
        } else {
          this.setPointDialogIsShow = true;
          this.dataToMap = {
            type: 'setOnePoint',
            data: {
              id: this.currentRow.id,
              direction: this.currentRow.direction,
              point: this.currentRow.right_bottom.point
            }
          };
          setTimeout(() => {
            this.$refs.shipmap.load();
          }, 10);
        }
      },

      setLocation(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.$router.push({path: "/monitoring/realtime"});
      },

      setBaseStation(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        alert('设置基站，和前面“船舱总段”一样');
      },

      handleClick(tab, event){
        console.log(tab, event);
      },

      handleClick22(tab, event){
        console.log(tab, event);
      },

      setActive(index) {
        console.log(this.allBaseStations[index].id);
        let id = this.allBaseStations[index].id;
        let hasBaseStationIds = [...this.hasBaseStationIds];
        let isHas = hasBaseStationIds.indexOf(id);
        if (isHas > -1) {
          hasBaseStationIds.splice(index, 1);
        } else {
          hasBaseStationIds.push(id);
        }
        this.hasBaseStationIds = hasBaseStationIds;
        console.log(this.hasBaseStationIds);
      },

      submitAuth(){
        this.unlockIsShow = false;
      },

      setUnlock(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.unlockIsShow = true;
      },

      setLock(){
      },

      setMap(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.$router.push({path: "/monitoring/realtime"});
      },

      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },

      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },

      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.addDialogShow = true;
      },

      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      },

      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
      },

      getData(flag) {
        let obj = Object.assign({}, this.obj);
        obj.page = flag ? this.pagination.page : 1;
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.tableLoading = true;
        this.tableLoading = false;
        this.pagination.total = 222;
        let list = [];
        for (let i = 1; i < 11; i++) {
          list.push({id: i, name: '姓名' + i});
        }
        this.list = mock.stair;
        this.allBaseStations = list;
      },

      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },

      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },

      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {'v-ship-map-set-area': ShipMapSetArea}
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import "../../common/less/ship-map.less";

  .params-stair-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .div {
      flex: 1;
      width: 0;
      display: flex;
      .input {
        flex: 1;
      }
      .btn {
        width: 80px;
      }
    }
    .auth-box {
      font-size: 13px;
      height: 400px;
      overflow-y: auto;
      border-top: 1px solid #dcdcdc;
      .item {
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        border-bottom: 1px solid #dcdcdc;
        span {
          height: 45px;
          line-height: 45px;
          display: block;
          float: left;
        }
        &.active {
          background: #f9f9f9;
        }
        .check {
          display: inline-block;
          width: 30px;
        }
        .color-409eff {
          color: #409eff;
        }
        .color-dcdcdc {
          color: #dcdcdc;
        }
      }
    }
  }
</style>
